import { useEffect } from "react";
import "@/App.css";
import axios from "axios";
import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { Portfolio } from "@/components/Portfolio";
import { Clients } from "@/components/Clients";
import { Nosotros } from "@/components/Nosotros";
import { Footer } from "@/components/Footer";
import { WhatsAppFAB } from "@/components/WhatsAppFAB";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  useEffect(() => {
    // Non-blocking healthcheck ping
    axios.get(`${API}/`).catch(() => {});
  }, []);

  return (
    <div className="App bg-black text-white min-h-screen font-mono">
      <Navigation />
      <main data-testid="main-content">
        <Hero />
        <Portfolio />
        <Clients />
        <Nosotros />
      </main>
      <Footer />
      <WhatsAppFAB />
    </div>
  );
}

export default App;
